// InvoiceDataDraftApi.ts
import type {
    BaseQueryFn,
    FetchArgs,
    FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { selectAuth } from "../features/authSlice";
import { RootState } from "../store";
import { API_END_POINTS } from './apiEndpoints';
import { baseUrl } from './baseUrl';
import { DynamicBaseQueryHeader } from './DynamicBaseQueryHeader';

export const InvoiceDataDraftApi = createApi({
    reducerPath: 'InvoiceDataDraftApi',
    baseQuery: DynamicBaseQueryHeader("InvoiceDataDraft"),
    endpoints: (builder) => ({

        getAllDraftInvoices: builder.query({
            query: (params) => ({
                url: `${API_END_POINTS.getAllDraftInvoices}`,
                method: "GET",
                params
            }),
        }),

        getAllDraftInvoicesAdmin: builder.query({
            query: (params) => ({
                url: `${API_END_POINTS.getAllDraftInvoicesAdmin}`,
                method: "GET",
                params
            }),
        }),

        uploadOCRInvoice: builder.mutation({
            query: (body) => ({
                url: API_END_POINTS.uploadOCRInvoice,
                method: "POST",
                body,
            }),
        }),

        deleteReceiptById: builder.mutation({
            query: (InvoiceDataDraftId) => ({
                url: `${API_END_POINTS.deleteReceiptById}?InvoiceDataDraftId=${InvoiceDataDraftId}`,
                method: "DELETE"
            }),
        }),

        uploadOCRInvoices: builder.mutation({
            query: (body) => ({
                url: API_END_POINTS.UploadOCRInvoicesLatest,
                method: "POST",
                body,
            }),
        }),

        getInvoiceDetailById: builder.query({
            query: (InvoiceDataDraftId) => ({
                url: `${API_END_POINTS.GetInvoiceDetailById}?DataDraftId=${InvoiceDataDraftId}`,
                method: "GET"
            }),
        }),
    }),
})

export const {
    useGetAllDraftInvoicesQuery,
    useGetAllDraftInvoicesAdminQuery,
    useUploadOCRInvoiceMutation,
    useDeleteReceiptByIdMutation,
    useUploadOCRInvoicesMutation,
    useGetInvoiceDetailByIdQuery,
    useLazyGetInvoiceDetailByIdQuery, 
} = InvoiceDataDraftApi